import React from "react";
import { useNavigate } from "react-router-dom";

import { Button } from "@/components";
import emptyHistory from "@/assets/img/emptyHistory.svg";
import styles from "./EmptyHistory.module.scss";

export const EmptyHistory = () => {
  const navigate = useNavigate();

  const handleNavigate = () => {
    navigate("/");
  };

  return (
    <div className={styles.emptyHistory}>
      <img src={emptyHistory} alt="emptyHistory" className={styles.emptyHistoryImage} />
      <p className={styles.emptyHistoryTitle}>
        Похоже у Вас нет актуальных бронирований и покупок
      </p>
      <Button newStyles={styles.emptyHistoryButton} onClickFunc={handleNavigate}>
        <span>Арендовать корт</span>
      </Button>
    </div>
  );
};
